/*
 * @Author: 吴文洁 
 * @Date: 2019-10-17 18:24:53 
 * @Last Modified by: 吴文洁
 * @Last Modified time: 2019-10-18 11:16:17
 处理字符串
 */

/**
  处理换行字符
 */

const replaceString = (str: string) : string => { 
  return str.replace(/\n/g, '<br/>');
}

/**
  处理换行字符
 */
const replaceStringReverse = (str: string): string => {
  return str.replace(/<br\/>/g, '\n');
}

/**
  处理多行字符
 */
const replaceMultiLineString = (str: string): string => {
  return str.replace(/\n/g, '');
}

const pickHtmlTextContent = (str: string): string => {
  const divDom: any = document.createElement('div');
  divDom.innerHTML = str;
  return divDom.textContent;
}

export {
  replaceString,
  pickHtmlTextContent,
  replaceStringReverse,
  replaceMultiLineString
}